import { useEffect, useState } from "react";
import { FaRegHandPointLeft } from "react-icons/fa6";
import { IoSearchOutline } from "react-icons/io5";
import logo from "/aapedtech.png";
import { Outlet, useLocation } from "react-router-dom";
import axios from "axios";
import Topbar from "../components/shared/Topbar";

export default function ChatLayout() {
    const [path, setPath] = useState('');
    const [ishide, setHide] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const apiUrl = import.meta.env.VITE_APP_API;
    const [homePageData, setHomePageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchHomePageData = async () => {
            try {
                const response = await axios.get(
                    `${apiUrl}/api/account/organization_home_page`
                );
                console.log(response.data);

                setHomePageData(response.data);
            } catch (error) {
                console.error("Error fetching organization data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchHomePageData();
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setPath(window.location.pathname);
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Initial check
        handleResize();

        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);

        // Update the hide state whenever path or isMobile changes
        const shouldHide = isMobile && (location.pathname === '/chats/support-chat' || location.pathname === '/chats/ai-chat');
        setHide(shouldHide);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [path, isMobile]); // Added isMobile to the dependency array

    return (
        <>
        <Topbar homePageData={homePageData} loading={loading} />
            <div className="lg:h-screen overflow-hidden mt-20">
                <div className="lg:grid lg:grid-cols-12">
                    <div className={`h-screen lg:col-span-3 ${ishide ? 'hidden' : ''}`}>
                        <div className="pb-5 pt-5 border-r-2 lg:h-screen space-y-2 px-2">
                            <div className="fancy-outer">
                                <a
                                    className=" w-full"
                                    href={homePageData?.organization?.id==7 ? `/chats/ai-chat` : `/chats/support-chat`}
                                >
                                    <div className="fancy-inner flex items-center gap-4">
                                        <div className="w-52 h-48 md:w-24 md:h-24 lg:w-32 lg:h-32 bg-white rounded-full flex items-center justify-center">
                                            <img
                                                width={100}
                                                height={100}
                                                className="rounded-full"
                                                src={`${apiUrl}${homePageData?.organization?.logo}`}
                                                alt=""
                                            />
                                        </div>
                                        <p>
                                            <span className="font-bold text-2xl md:text-xl">{homePageData?.organization?.title}</span><br />
                                            <span className="text-xl md:text-lg">                                    যেকোন প্রশ্ন বা কাজ থাকলে আমাদেরকে জানান
                                            </span>
                                        </p>
                                    </div>
                                </a>
                            </div>

                            <div className="fancy-outer">
                                <a
                                    className="w-full"
                                    href={`/chats/ai-chat`}
                                >
                                    <div className="fancy-inner flex items-center gap-2">
                                        <div className="w-32 h-32 md:w-24 md:h-24 lg:w-24 lg:h-24 bg-white rounded-full flex items-center justify-center">
                                            <img
                                                width={100}
                                                height={100}
                                                className="rounded-full"
                                                src={`https://i.ibb.co.com/DDTYJsXW/image.png`}
                                                alt=""
                                            />
                                        </div>
                                        <p>
                                            <span className="font-bold text-2xl nd:text-xl">CHAT AI</span><br />
                                            <span className="text-xl md:text-lg">                                    যেকোন প্রশ্ন করলে উত্তর করবে AI
                                            </span>
                                        </p>
                                    </div>
                                </a >
                            </div>
                        </div>
                    </div>
                    <div className="col-span-9 bg-gray-100">
                        <div className="w-full"><Outlet /></div>
                    </div>
                </div>
            </div></>
    );
}